import { LoquixFollowUpSuggestions } from './loquix-follow-up-suggestions.js';

if (!customElements.get('loquix-follow-up-suggestions')) {
  customElements.define('loquix-follow-up-suggestions', LoquixFollowUpSuggestions);
}
